export default __webpack_public_path__ + "static/media/VideoCameraSlash_3.5e5da206.svg";